import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  buttonMb: {
    '&&': {
      marginBottom: SPACES.xxl,
    },
  },
  modalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      maxHeight: 'calc(100vh - 100px)',

      [theme.breakpoints.down('tablet')]: {
        width: 'calc(100vw - 40px)',
        height: 600,

        padding: SPACES.l,
        gap: SPACES.xl,
      },
      [theme.breakpoints.up('tablet')]: {
        height: 800,
        width: 700,
        maxWidth: 'calc(100vw - 80px)',

        padding: SPACES.xxxxl,
      },
    },
  },
  upperWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xl,
      width: '100%',
    },
  },
  modalTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      color: theme.palette.custom.darkBlue2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.xl,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xxxl,
      },
    },
  },
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterWrapper: {
    display: 'flex',
    gap: SPACES.s,
    flexWrap: 'wrap',
  },
  imageListWrapper: {
    marginTop: SPACES.l,
    overflowY: 'auto',
  },
  imagesList: {
    '&&': {
      margin: 0,

      borderRadius: 5,

      [theme.breakpoints.down('tablet')]: {
        height: 416,
        maxHeight: 'calc(100vh - 290px)',
      },
      [theme.breakpoints.up('tablet')]: {
        height: 598,
        maxHeight: 'calc(100vh - 300px)',
      },

      scrollbarWidth: '6px',
      scrollbarColor: theme.palette.custom.grey2,
      '&::-webkit-scrollbar': {
        width: '6px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: theme.palette.custom.grey2,
        borderRadius: '10px',
      },
    },
  },
  imageItem: {
    '&&': {
      maxHeight: '300px',

      [theme.breakpoints.up('tablet')]: {
        width: 320,
      },
    },
  },
  image: {
    '&&': {
      maxHeight: 'calc(100% - 54px)',

      borderRadius: '5px',
    },
  },
  video: {
    '&&': {
      objectFit: 'cover',
      objectPosition: 'center',
      height: 240,
      width: '100%',
      borderRadius: '5px',

      [theme.breakpoints.up('tablet')]: {
        width: 320,
        height: 180,
      },
    },
  },
  playButton: {
    '&&': {
      position: 'absolute',
      top: '40%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      minWidth: 40,
      width: 45,
      height: 45,
      padding: 0,
      borderRadius: '50%',
      backgroundColor: theme.palette.custom.greyTransparent,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,

      '&:hover, &:focus': {
        backgroundColor: theme.palette.custom.grey2,
      },
    },
  },
  imageActionBtnWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
}))
